/**
 * Canicule — product showcase horizontal swipe (mobile)
 * Native momentum scroll; edge fades on viewport; taps on links must still work.
 */
(function () {
  'use strict';

  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var MOBILE_MQ = window.matchMedia('(max-width: 989px)');
  var DIRECTION_THRESHOLD = 10;
  var SWIPE_COMMIT = 14;

  function isMobile() {
    return MOBILE_MQ.matches;
  }

  function canScroll(track) {
    return track.scrollWidth > track.clientWidth + 2;
  }

  function getViewport(track) {
    return track.closest('.canicule-product-showcase__viewport');
  }

  function updateScrollState(track) {
    var scrollable = isMobile() && canScroll(track);
    var atStart = track.scrollLeft <= 2;
    var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    var viewport = getViewport(track);

    if (viewport) {
      viewport.classList.toggle('is-scrollable', scrollable);
      viewport.classList.toggle('is-at-start', atStart);
      viewport.classList.toggle('is-at-end', atEnd);
    }

    var inner = track.closest('.canicule-product-showcase__inner');
    var hint = inner ? inner.querySelector('.canicule-product-showcase__scroll-hint') : null;
    if (hint) {
      hint.hidden = !scrollable;
    }
  }

  function initTrack(track) {
    if (track._caniculeShowcaseInit) {
      updateScrollState(track);
      return;
    }
    track._caniculeShowcaseInit = true;

    var startX = 0;
    var startY = 0;
    var startScrollLeft = 0;
    var dragging = false;
    var horizontal = false;
    var maxDeltaX = 0;
    var suppressClick = false;

    var refreshQueued = false;
    function refresh() {
      if (refreshQueued) return;
      refreshQueued = true;
      requestAnimationFrame(function () {
        refreshQueued = false;
        updateScrollState(track);
      });
    }

    refresh();

    track.addEventListener('scroll', refresh, { passive: true });

    if (typeof ResizeObserver !== 'undefined') {
      var observer = new ResizeObserver(refresh);
      observer.observe(track);
      track.querySelectorAll('img').forEach(function (img) {
        if (!img.complete) {
          img.addEventListener('load', refresh, { once: true });
        }
      });
    }

    window.addEventListener('load', refresh, { once: true });

    if (prefersReducedMotion) return;

    track.addEventListener(
      'click',
      function (event) {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        suppressClick = false;
      },
      true
    );

    track.addEventListener(
      'touchstart',
      function (event) {
        if (!isMobile() || !event.touches.length) return;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        startScrollLeft = track.scrollLeft;
        dragging = true;
        horizontal = false;
        maxDeltaX = 0;
        suppressClick = false;
      },
      { passive: true }
    );

    track.addEventListener(
      'touchmove',
      function (event) {
        if (!dragging || !event.touches.length) return;

        var deltaX = startX - event.touches[0].clientX;
        var deltaY = event.touches[0].clientY - startY;

        if (!horizontal) {
          if (Math.abs(deltaX) < DIRECTION_THRESHOLD && Math.abs(deltaY) < DIRECTION_THRESHOLD) {
            return;
          }
          horizontal = Math.abs(deltaX) > Math.abs(deltaY);
        }

        if (!horizontal) return;

        maxDeltaX = Math.max(maxDeltaX, Math.abs(deltaX));
        track.classList.add('is-dragging');
      },
      { passive: true }
    );

    function endDrag(event) {
      if (!dragging) return;
      dragging = false;
      horizontal = false;
      track.classList.remove('is-dragging');

      var touchDelta = 0;
      if (event && event.changedTouches && event.changedTouches.length) {
        touchDelta = Math.abs(startX - event.changedTouches[0].clientX);
      }

      var scrollDelta = Math.abs(track.scrollLeft - startScrollLeft);

      if (maxDeltaX >= SWIPE_COMMIT || touchDelta >= SWIPE_COMMIT || scrollDelta >= 8) {
        suppressClick = true;
        window.setTimeout(function () {
          suppressClick = false;
        }, 320);
      }

      maxDeltaX = 0;
      refresh();
    }

    track.addEventListener('touchend', endDrag, { passive: true });
    track.addEventListener('touchcancel', endDrag, { passive: true });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-product-showcase-carousel]').forEach(initTrack);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  if (MOBILE_MQ.addEventListener) {
    MOBILE_MQ.addEventListener('change', function () {
      init(document);
    });
  }
})();
